/**
 * Wrapper personnalisé pour fetch qui gère automatiquement les erreurs 401
 * Redirige vers /auth-login si le token a expiré
 */

const handleUnauthorized = () => {
    // Effacer le token et l'utilisateur du localStorage
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");

    // Rediriger vers la page de login
    window.location.href = "/auth-login";
};

/**
 * Effectue une requête fetch avec gestion automatique des 401
 * @param {string} url - L'URL de la requête
 * @param {object} options - Les options fetch (incluant credentials, headers, etc.)
 * @returns {Promise} - La réponse JSON ou une erreur
 */
export const customFetch = async (url, options = {}) => {
    try {
        // Ajouter les credentials par défaut pour envoyer les cookies
        const fetchOptions = {
            credentials: "include",
            ...options,
        };

        const response = await fetch(url, fetchOptions);

        // Vérifier le statut 401 (non autorisé)
        if (response.status === 401) {
            handleUnauthorized();
            // Retourner une erreur en attendant la redirection
            return Promise.reject(new Error("Session expired - redirecting to login"));
        }

        // Si la réponse n'est pas ok (status > 299)
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.message || `HTTP Error: ${response.status}`
            );
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // Log l'erreur mais ne pas crasher l'app
        console.error("Fetch error:", error);
        window.location.href = "/auth-login";
        throw error;
    }
};

export default customFetch;
